module.exports = __webpack_public_path__ + "static/media/face.1fb773f9.jpeg";